import { IconTextFormatSubheading } from '@components/icons/text-format-subheading';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';
import { useTextContentActions } from './use-field-actions';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'subheading'>;

const Display: Config['Display'] = ({ field }) => {
  return <Text font="heading2" text={field.label} />;
};

const FormBuilderSubheading: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;
  const menuItems = useTextContentActions(field);

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={
          <TextField
            onChange={actions.createChangeHandler(field, 'label')}
            defaultValue={field.label}
            label={field.label}
            hideLabel
          />
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Subheading',
  },
});

export const subheadingConfig: Config = {
  kind: 'subheading',
  title: t('title'),
  group: 'content',
  propertiesTabs: [conditionsTab],
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={field.label} />,
  Component: FormBuilderSubheading,
  Icon: IconTextFormatSubheading,
};
